export enum UserSessionTypes {
    SHOW_USER_SESSION_LOADING = "SHOW_USER_SESSION_LOADING",
    HIDE_USER_SESSION_LOADING = "HIDE_USER_SESSION_LOADING",

    REQUEST_LOGIN_CODE = "REQUEST_LOGIN_CODE",
    VERIFY_LOGIN_CODE = "VERIFY_LOGIN_CODE",

    LOGIN_USER = "LOGIN_USER",

    LOGOUT_USER = "LOGOUT_USER",

    REQUEST_USER_INFO = "REQUEST_USER_INFO",
    SET_USER_INFO = "SET_USER_INFO",
    UPDATE_PROFILE = "UPDATE_PROFILE",

    SEE_PWA_GUID = "SEE_PWA_GUID",
    UN_SEE_PWA_GUID = "UN_SEE_PWA_GUID",

    HIDE_PACKAGE_BANNER = "HIDE_PACKAGE_BANNER",
    CLEAR_LOGIN_INFO = "CLEAR_LOGIN_INFO",

    REMIND_PROFILE_COMPLETE_LATER = "REMIND_PROFILE_COMPLETE_LATER"
}